import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; // Correct import statement for useNavigate
import './styles.scss';
import { Typography, useTheme } from "@mui/material";

export const Breadcrum = ({
  className = "breadcrumb",
  icon,
  items = [] // Pass the items prop
}) => {

  const navigate = useNavigate();

  const { gTheme } = useSelector(state => state.theme);

  const theme = gTheme !== "light" ? "dark" : "";

  const separator = <>&nbsp;{">"}&nbsp;</> 

  return (
    <ul className={`${theme} ${className}`} style={{ color: "#546F7A" }}>
      {items.map((item, index) => (
        <li key={index} className="item"> {/* Added key prop */}
          {item.route ? ( // Check if the item has a route
            <>
              <a onClick={() => navigate(item.route)}>
                {item.label} 
              </a>
              { index !== items.length - 1 ? separator : "" }
            </>
          ) : (
            <Typography component="span" fontSize={11} fontWeight={600}>
              {item.label} { index !== items.length - 1 ? separator : "" }
            </Typography>
          )}
        </li>
      ))}
    </ul>
  );
};
